import { ChevronDownIcon, XMarkIcon } from "components/Icons";

import { BUTTON_COLORS } from "components/Constants/constants";
import { classNames } from "tools/ui";

const [bgBtnColor, txtBtnColor] = BUTTON_COLORS.rose;
const baseIcon =
  "absolute right-4 top-3 w-9 rounded-full p-2 active:scale-90 fill-current";
const defaultStylePanel =
  "bg-gray-100 px-2 custom-transition duration-500 sticky w-1/3";

const PanelRight = ({ children, title, displayOpen, handleDisplay, style }) => {
  const headerStyle = displayOpen ? "pt-5 space-y-3 w-full" : "";

  let stylePanel =
    "fixed bottom-[50%] right-[-123px] bg-gray-800 w-65 md:w-75 h-[4rem] rounded-b-2xl overflow-hidden rotate-90 animate-fade-left animate-ease-linear transition-all duration-500 shadow-2xl shadow-slate-200";
  let buttonStyle = "right-3 top-1";
  if (displayOpen) {
    stylePanel = style || defaultStylePanel;
    buttonStyle = "right-1 top-3";
  }

  return (
    <div id="panel-right" className={stylePanel}>
      {handleDisplay && (
        <button
          className={classNames("absolute", buttonStyle)}
          onClick={() => handleDisplay(!displayOpen)}
        >
          {displayOpen ? (
            <XMarkIcon
              className={classNames(baseIcon, bgBtnColor, txtBtnColor)}
            />
          ) : (
            <ChevronDownIcon
              className={classNames(
                baseIcon,
                "bg-white text-gray-800 fill-current",
              )}
            />
          )}
        </button>
      )}

      <div className={classNames("px-3 py-3", headerStyle)}>
        <h3
          className={classNames(
            "truncate font-bold mb-2",
            displayOpen
              ? "text-zinc-700 text-center text-2xl"
              : "pt-4 md:pt-3 pl-3 text-white text-left text-lg lg:text-xl",
          )}
        >
          {title}
        </h3>
        {displayOpen && children}
      </div>
    </div>
  );
};

export default PanelRight;
